import { render, staticRenderFns } from "./ZTabItem.vue?vue&type=template&id=01d9f0e4&"
import script from "./ZTabItem.vue?vue&type=script&lang=js&"
export * from "./ZTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports